module.exports = __webpack_public_path__ + "img/2-2.1eada227.jpg";